import { PlaceAssetsController } from './place-assets.controller';

export const PlaceAssetsComponent = {
  bindings: {
    place: '<',
  },
  templateUrl: 'places/place/components/place-assets/place-assets.html',
  controller: PlaceAssetsController,
};
